import { render, staticRenderFns } from "./MainErrors.vue?vue&type=template&id=bfb2b022&scoped=true"
import script from "./MainErrors.vue?vue&type=script&lang=js"
export * from "./MainErrors.vue?vue&type=script&lang=js"
import style0 from "./MainErrors.vue?vue&type=style&index=0&id=bfb2b022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2b022",
  null
  
)

export default component.exports